import React from "react";
import { useI18n } from "../i18n/LanguageContext";

// Landesflaggen + Beschriftung: Deutsch (DE) und Englisch (GB/UK).
const FLAGS = {
  de: { emoji: "\uD83C\uDDE9\uD83C\uDDEA", code: "DE", label: "Deutsch" },
  en: { emoji: "\uD83C\uDDEC\uD83C\uDDE7", code: "EN", label: "English" },
};

/**
 * Sprach-Umschalter mit Landesflaggen und Beschriftung (DE | EN).
 */
export default function LanguageToggle({ className = "" }) {
  const { lang, setLang, t } = useI18n();
  const labels = t.langToggle;
  const codes = ["de", "en"];

  return (
    <div
      className={`inline-flex items-center gap-1 rounded-full border border-blue-100 bg-white/90 backdrop-blur px-1 py-1 shadow-sm ${className}`}
      role="group"
      aria-label={labels.aria}
      data-testid="language-toggle"
    >
      {codes.map((code) => {
        const active = lang === code;
        return (
          <button
            key={code}
            type="button"
            onClick={() => setLang(code)}
            aria-pressed={active}
            aria-label={FLAGS[code].label}
            title={FLAGS[code].label}
            data-testid={`lang-${code}`}
            className={`flex items-center gap-1.5 h-8 pl-2 pr-2.5 rounded-full leading-none transition-all ${
              active
                ? "bg-blue-brand/10 ring-2 ring-blue-brand text-blue-brand"
                : "text-ink/60 opacity-70 hover:opacity-100 hover:text-blue-brand"
            }`}
          >
            <span className="text-base" aria-hidden="true">{FLAGS[code].emoji}</span>
            <span className="font-head font-bold text-[13px] uppercase tracking-wide">{FLAGS[code].code}</span>
          </button>
        );
      })}
    </div>
  );
}
